import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import 'firebase/compat/performance';
import router from "./routes/index";
import i18n from "@/i18n";
import store from "./store";
import VueExcelXlsx from "vue-excel-xlsx";
import VueMeta from "vue-meta";
import VueQrcodeReader from "vue-qrcode-reader";
import VueKonva from 'vue-konva';
import VueClipboard  from "vue-clipboard2";
import browserDetect from "vue-browser-detect-plugin";
import VueSocialSharing from 'vue-social-sharing'
import titleMixin from "@/mixins/titleMixin";
import VueWordCloud from 'vuewordcloud';
import VueNumber from 'vue-number-animation'
import Ads from 'vue-google-adsense'
import x5GMaps from 'x5-gmaps';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import VCalendar from 'v-calendar';
import birthDatepicker from 'vue-birth-datepicker';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueCountdown from '@chenfengyuan/vue-countdown';
import Carousel3d from 'vue-carousel-3d';
import device from "vue-device-detector"


window.axios = axios;
axios.defaults.baseURL = process.env.VUE_APP_API;
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true
Vue.mixin(titleMixin)
Vue.use(VueExcelXlsx);
Vue.use(Carousel3d);
Vue.use(device)

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(birthDatepicker);
Vue.use(VueMeta);
Vue.use(VueQrcodeReader);
Vue.use(VueKonva, { prefix: 'Konva'});
Vue.use(VueClipboard);
Vue.use(browserDetect);
Vue.use(VueSocialSharing);
Vue.component(VueWordCloud.name, VueWordCloud);
Vue.use(VueNumber);
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)
Vue.use(x5GMaps, { key: 'AIzaSyCXm1SR1hOSNMDrCOeMQr7XQSDSS-YKyBg', libraries: ['places'] });


Vue.use(VCalendar, {
    componentPrefix: 'vc',
    locales:{
        'es-PE': {
            firstDayOfWeek:2,
            masks: {
                L: 'DD/MM/YYYY',
                // ...optional `title`, `weekdays`, `navMonths`, etc
            }
        }
    }
});

Vue.use(VueReCaptcha, {
    siteKey: '6LeMXdUUAAAAADqfrL572D4mJ9_j0p0tc-HADIsj',
    loaderOptions: {
        useRecaptchaNet: true
    }
})
const configOptions = {
    apiKey: 'AIzaSyBTROuJ3i0eEeETK0_kQN4HQp7PHkGudu4',
    authDomain: "eventos-do-76766.firebaseapp.com",
    databaseURL: "https://eventos-do-76766.firebaseio.com",
    projectId: "eventos-do-76766",
    storageBucket: "eventos-do-76766.appspot.com",
    messagingSenderId: "275689703844",
    appId: '1:275689703844:web:1314ca3de7386946',
    measurementId: "G-HMHE82L7V3"
};

firebase.initializeApp(configOptions);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
firebase.analytics();
firebase.performance();

Sentry.init({
    Vue,
    dsn: "https://a456f2738b0e4e269d503ee8dce1606d@o216002.ingest.sentry.io/1356050",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracePropagationTargets: ["localhost", "tunay.app", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
            console.log('Service Worker registrado correctamente:', registration.scope);
        })
        .catch(error => {
            console.error('Error al registrar el Service Worker:', error);
        });
}

new Vue({
    i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
